import type { FeatureName } from '~/shared/feature-flag-service/feature-flag-service';

export const companyHomeRoute = {
    patterns: {
        companyHome: '/company',
    },
} as const;

// Home lives in the workspace navigation, and LaunchDarkly prerequisites are not on our plan, so the code requires both.
export const companyHomeFeatureFlags = [
    'company-home',
    'workspace-navigation',
] as const satisfies readonly FeatureName[];
